import React from 'react'
import KledoLoader from 'components/UI/KledoLoader'

const PersistLoading = () => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        zIndex: 9999,
      }}
    >
      <KledoLoader size={48} />
    </div>
  )
}

export default PersistLoading
